module.exports = __webpack_public_path__ + "static/media/cq_esporta.5940db16.svg";